import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { cfpBaseUrl, wfsBaseUrl } from '../../network/urls';

const initialState = {
    data: [],
    pageNumber: 1,
    pageSize: 20,
    subDivisionCode: '',
    officeCode: '',
    dateFrom: '',
    dateTo: '',
    totalRecords: '',
    totalPages: null,
    error: null,
}

// Define an async thunk for fetching paginated data
export const fetchPaginatedAllComplaintsForCFC = createAsyncThunk(
    'complaints/GetAllComplaintsForCFCBySubDivisionWithoutStatus',
    async ({ pageSize, pageNumber, subDivisionCode, dateFrom, dateTo, officeCode }, { getState }) => {
        const { auth } = getState();
        const { wmsPrivateToken } = auth;


        const myHeaders = new Headers();
        myHeaders.append("Authorization", wmsPrivateToken);

        const formdata = new FormData();
        formdata.append("pageNumber", pageNumber);
        formdata.append("pageSize", pageSize);
        formdata.append("subdivisionCode", subDivisionCode);
        formdata.append("dateFrom", '');
        formdata.append("dateTo", dateTo);
        formdata.append("officeCode", officeCode == 10 ? '1500007' : officeCode);
        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata,
            redirect: "follow"
        };

        const response = await fetch(cfpBaseUrl + `lineComplaints/GetAllComplaintsBySubDivisionWithoutStatus`, requestOptions);
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.Message || 'Complaints API issue!');
        }

        const result = await response.json();

        if (result.Message === "Data Not Found.") {
            throw new Error(result.Message, 'printing error message' || 'Unable to fetch stats!');
        }

        return result;
    }
);

const getAllComplaintsForCFCPaginatedSlice = createSlice({
    name: 'getAllComplaintsForCFC',
    initialState: initialState,
    reducers: {
        nextPage(state) {
            state.pageNumber += 1;
        },
        previousPage(state) {
            if (state.pageNumber > 1) {
                state.pageNumber -= 1;
            }
        },
        firstPage(state) {
            state.pageNumber = 1;
        },
        lastPage(state, action) {
            state.pageNumber = action.payload;
        },
        resetState(state) {
            state.data = []
            state.pageNumber = 1
            state.pageSize = 20
            state.subDivisionCode = ''
            state.officeCode = ''
            state.dateFrom = ''
            state.dateTo = ''
            state.totalRecords = ''
            state.totalPages = null
            state.error = null
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchPaginatedAllComplaintsForCFC.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchPaginatedAllComplaintsForCFC.fulfilled, (state, action) => {
                state.isLoading = false;
                if (action.payload.Data) {
                    state.data = action.payload.Data.requestedComplaint;
                } else {
                    state.data = [];
                }
                if (action.payload.totalPages) {
                    state.totalPages = action.payload.totalPages;
                } else {
                    state.totalPages = 1;
                }
                state.totalRecords = action.payload.totalRecords;
                state.error = null;
            })
            .addCase(fetchPaginatedAllComplaintsForCFC.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
                state.totalPages = null;
                state.data = [];
                state.totalRecords = null;
            });
    }
});

export const { nextPage, previousPage, firstPage, lastPage, resetState } = getAllComplaintsForCFCPaginatedSlice.actions;

export default getAllComplaintsForCFCPaginatedSlice.reducer;
